import { Gavel } from "lucide-react";
import { useEffect, useState } from "react";
import HearingCard from "./HearingCard";
import "./upcomingHearings.css";
import { useNavigate } from "react-router-dom";

import { getUpcomingHearings } from "../../../services/dashboardService";

export default function UpcomingHearings() {
  const navigate = useNavigate();
  const [hearings, setHearings] = useState([]);

useEffect(() => {
  const loadHearings = async () => {
    const data = await getUpcomingHearings();
    setHearings(data);
  };

  loadHearings();
}, []);
  return (
    <div className="dashboard-panel">

      <div className="panel-header">

        <div className="panel-title">

          <Gavel size={18} />

          <span>Upcoming Hearings</span>

        </div>

        <button className="panel-link"
        onClick={() => navigate("/portal/calendar")}>
          View Calendar
        </button>

      </div>

      {hearings.length === 0 ? (
  <div className="no-hearings">
    No upcoming events
  </div>
) : (
  hearings.map((hearing) => {
    const eventDate = new Date(hearing.date);

    return (
      <HearingCard
        key={hearing.docId}
        date={eventDate.getDate()}
        month={eventDate
          .toLocaleString("en-US", { month: "short" })
          .toUpperCase()}
        time={hearing.time}
        title={hearing.title}
        court={hearing.description || "Calendar Event"}
      />
    );
  })
)}

    </div>
  );
}